export default __webpack_public_path__ + "static/media/magicsnacks@3x.fe96ec93.jpg";